export const shouldShowWelcome = (
  pathname: string,
  search: string,
  token: string | null
): boolean => {
  const params = new URLSearchParams(search)

  return !token && pathname === '/' && params.size === 0
}
